import * as React from "react"
import { useEffect } from "react"
import { useComputed } from "@preact/signals-react"
import { object, string } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"
import { TextFieldSeeker } from "@ui-seeker/core"

import { useAdminSkuForm } from "../../@hooks"
import { adminSkuFormData, adminSkuFormErrors } from "../../@signals"


export default function AdminSkuFormSkuName() {
    const isCreate = useComputed(() => adminSkuFormData.value.skuID === null)
    const brandName = useComputed(() => isCreate.value ? `${adminSkuFormData.value.brandName || ""} ` : "")

    const { localValue, handleChange } = useAdminSkuForm("skuName")
    const { errors } = useValidatorSeeker({
        skuName: localValue
    }, object({
        skuName: string().required("SKU name is mandatory")
    }))

    useEffect(() => {
        adminSkuFormErrors.value = {
            ...adminSkuFormErrors.value,
            skuName: errors?.skuName || ""
        }
    }, [errors?.skuName])

    return <TextFieldSeeker
        label="SKU name"
        error={errors?.skuName}
        value={`${brandName.value}${localValue || ""}`}
        onChange={e => handleChange(e.target.value.replace(brandName.value, ""))}
    />
}